module.exports = __webpack_public_path__ + "media/images/riders/PHIL_ATWILL-4483acab113aafe9485cc124c615324c.png";